<template>
    <v-card>

        <v-container fluid class="pt-2">
            <v-row dense>
                <v-col cols="12" md="3" sm="6" xs="12">

                    <v-card
                        height="100%"
                        class="mx-auto"
                    >
                        <v-toolbar
                            color="primary"
                            dark
                            dense
                        >
                            <v-toolbar-title>Geo location</v-toolbar-title>

                        </v-toolbar>

                        <v-list>
                            <v-list-item @click="" v-for="(value,name) in testData.geoIp" :key="name">

                                <v-list-item-icon>
                                    <v-icon>mdi-map-marker-check</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ value }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{ name }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                            </v-list-item>

                        </v-list>
                    </v-card>

                </v-col>

                <v-col cols="12" md="3" sm="6" xs="12">

                    <v-card
                        height="100%"
                        class="mx-auto"
                    >
                        <v-toolbar
                            color="primary"
                            dark
                            dense
                        >
                            <v-toolbar-title>Recruitment source</v-toolbar-title>

                        </v-toolbar>

                        <v-list two-line v-if="testData.source">
                            <v-list-item>

                                <v-list-item-icon>
                                    <v-icon>mdi-magnet-on</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ testData.source.name }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Recruitment source name
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item>

                                <v-list-item-icon>
                                    <v-icon>mdi-check</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ testData.source.enabled }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Enabled
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item>

                                <v-list-item-icon>
                                    <v-icon>mdi-check</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ testData.source.id ? testData.source.id : 'Not provided' }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        ID
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>


                            <v-list-item v-if="testData.answers && testData.answers.length > 0" class="cursor-pointer">

                                <v-list-item-icon>
                                    <v-icon>mdi-database</v-icon>
                                </v-list-item-icon>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-list-item-content v-on="on">
                                            <v-list-item-title>
                                                <div>{{ testData.answers.length }}</div>
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                Incoming variables
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                    <div>
                                        Incoming variables
                                    </div>
                                    <v-chip v-for="dataVariable in testData.answers"
                                            :key="dataVariable"
                                            small
                                            class="mt-1 mb-1 mr-1">
                                        {{ dataVariable }}
                                    </v-chip>
                                </v-tooltip>

                            </v-list-item>

                            <v-list-item v-if="testData.integration">
                                <v-list-item-icon>
                                    <v-icon>mdi-access-point-network</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ testData.integration.name.toUpperCase() }}
                                    </v-list-item-title>

                                    <v-list-item-subtitle class="caption">
                                        Integration enabled
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                            </v-list-item>

                            <v-list-item v-show="testData.tune_enabled">

                                <v-list-item-icon>
                                    <v-icon>mdi-alpha-t-circle-outline</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ testData.tune_transaction_id }}
                                    </v-list-item-title>

                                    <v-list-item-subtitle>
                                        Tune transaction ID
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                            </v-list-item>

                        </v-list>

                    </v-card>
                </v-col>

                <!-- SECURITY CHECKS -->

                <v-col cols="12" md="3" sm="6" xs="12">

                    <v-card
                        height="100%"
                        class="mx-auto"
                    >
                        <v-toolbar
                            color="primary"
                            dark
                            dense
                        >
                            <v-toolbar-title>Security checks</v-toolbar-title>

                        </v-toolbar>

                        <v-list two-line>

                            <!-- OUT OF COUNTRY -->
                            <v-list-item>

                                <v-icon :color="testData.checks.isOutOfCountry ? 'red' : 'green'" large class="mr-5">
                                    {{ testData.checks.isOutOfCountry ? 'mdi-close-box' : 'mdi-check-circle' }}
                                </v-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ testData.checks.isOutOfCountry ? 'Yes' : 'No' }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Is out of country
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <!-- IS PROXY -->
                            <v-list-item>

                                <v-icon :color="testData.checks.isProxy ? 'red' : 'green'" large class="mr-5">
                                    {{ testData.checks.isProxy ? 'mdi-close-box' : 'mdi-check-circle' }}
                                </v-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ testData.checks.isProxy ? 'Yes' : 'No' }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Is proxy or VPN user
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <!-- IS DUPLICATE -->
                            <v-list-item>

                                <v-icon :color="testData.checks.isDuplicate ? 'red' : 'green'" large class="mr-5">
                                    {{ testData.checks.isDuplicate ? 'mdi-close-box' : 'mdi-check-circle' }}
                                </v-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ testData.checks.isDuplicate ? 'Yes' : 'No' }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Is already registered
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <!-- IS BOT -->
                            <v-list-item>

                                <v-icon :color="testData.detected.isBot ? 'red' : 'green'" large class="mr-5">
                                    {{ testData.detected.isBot ? 'mdi-close-box' : 'mdi-check-circle' }}
                                </v-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ testData.detected.isBot ? 'Yes' : 'No' }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Is bot
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <!-- HOSTED SERVER -->
                            <v-list-item>

                                <v-icon :color="testData.detected.isHostedServer ? 'red' : 'green'" large class="mr-5">
                                    {{ testData.detected.isHostedServer ? 'mdi-close-box' : 'mdi-check-circle' }}
                                </v-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ testData.detected.isHostedServer ? 'Yes' : 'No' }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Is hosted server or corporate VPN
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item v-if="researchDefender">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Research Defender
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item v-if="researchDefender">

                                <v-icon :color="researchDefender.Surveys[0].failure_reason ? 'red' : 'green'" large
                                        class="mr-5">
                                    {{ researchDefender.Surveys[0].failure_reason ? 'mdi-close-box' : 'mdi-check-circle' }}
                                </v-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ researchDefender.Surveys[0].failure_reason ? 'Yes' : 'No' }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{
                                            getRDFailureDescription(parseInt(researchDefender.Surveys[0].failure_reason))
                                        }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item v-if="researchDefender">

                                <v-card min-width="30" label small color="red" class="text-center pl-1 pr-1 white--text mr-5 text-h6">
                                    {{ researchDefender.Respondent.threat_potential_score }}
                                </v-card>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        Threat score
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Threat potential {{ researchDefender.Respondent.threat_potential }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                        </v-list>
                    </v-card>

                </v-col>

                <!-- DEVICE DATA -->

                <v-col cols="12" md="3" sm="6" xs="12">

                    <v-card
                        height="100%"
                        class="mx-auto"
                    >
                        <v-toolbar
                            color="primary"
                            dark
                            dense
                        >
                            <v-toolbar-title>Device</v-toolbar-title>

                        </v-toolbar>

                        <v-list two-line>

                            <!-- FINGER PRINT -->
                            <v-list-item>

                                <v-list-item-icon>
                                    <v-icon>mdi-fingerprint</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <div v-on="on">
                                                    {{ fingerprint }}
                                                </div>
                                            </template>
                                            {{ fingerprint }}
                                        </v-tooltip>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Machine fingerprint
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <!-- AGENT FAMILY -->
                            <v-list-item>

                                <v-list-item-icon>
                                    <v-icon>{{ deviceTypeIcon }}</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">

                                                <div v-on="on">
                                                    {{ testData.detected.agent }}
                                                </div>
                                            </template>
                                            {{ testData.detected.agent }}
                                        </v-tooltip>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        User agent
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <!-- BROWSER FAMILY -->
                            <v-list-item>

                                <v-list-item-icon>
                                    <v-icon>{{ deviceTypeIcon }}</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ testData.detected.browser }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Browser name and version
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <!-- PLATFORM NAME -->
                            <v-list-item>

                                <v-list-item-icon>
                                    <v-icon>{{ deviceTypeIcon }}</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ testData.detected.os }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Operating system and version
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <!-- PLATFORM TYPE -->
                            <v-list-item>

                                <v-list-item-icon>
                                    <v-icon>{{ deviceTypeIcon }}</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ testData.detected.device }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Device type
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                        </v-list>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>

import Debug from "@/components/UI/Debug.vue";
import researchDefenderFailureCodeMixin from "@/components/mixins/researchDefenderFailureCodeMixin.js";

export default {

    name: "TestData",

    mixins: [researchDefenderFailureCodeMixin],

    components: {Debug},

    props: {

        testData: {
            required: true,
            type: Object
        },

        fingerprint: {
            required: false,
            type: String,
            default: 'Unknown'
        },

        researchDefender: {
            required: false,
            type: Object | null
        }
    },

    computed: {

        deviceTypeIcon() {
            if (this.testData && this.testData.detected.device === "Mobile") return 'mdi-cellphone';
            if (this.testData && this.testData.detected.device === "Desktop") return 'mdi-laptop';
            if (this.testData && this.testData.detected.device === "Tablet") return 'mdi-tablet-ipad';
        }
    }
}
</script>
